import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import contractorActions from "../../../_actions/contractorActions";
import { toTitleCase } from "../../../_utils/generalUtils";

class EditContractorModal extends Component {
  state = {
    formData: {
      contractorId: 0,
      projectId: null, // A non-null projectId will add this contractor to the project.
      name: "",
      abbreviation: "",
      isJointVenture: false,
      assignToProject: false,
    },
    formErrors: {
      name: null,
      abbreviation: null,
    },
  };

  componentDidMount() {
    const { isNew, contractor, projectId, searchString } = this.props;
    this.setState({
      formData: {
        contractorId: isNew ? 0 : contractor.contractorId,
        projectId,
        name: isNew ? toTitleCase(searchString || "") : contractor.name,
        abbreviation: isNew ? "" : contractor.abbreviation,
        isJointVenture: isNew ? false : contractor.isJointVenture,
      },
    });
  }

  handleChange = (e) => {
    const fieldName = e.target.name;
    this.setState(
      {
        formData: { ...this.state.formData, [fieldName]: e.target.value },
      },
      () => this.validateForm(fieldName)
    );
  };

  handleChange_check = (e) =>
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.checked },
    });

  handleBlur = (e) => this.validateForm(e.target.name);

  validateForm = (fieldName) => {
    const { formData } = this.state;
    const formErrors = { ...this.state.formErrors };
    switch (fieldName) {
      case "name":
        if (!formData.name) formErrors.name = "Required";
        else formErrors.name = null;
        break;
      case "abbreviation":
        if (!formData.abbreviation) formErrors.abbreviation = "Required";
        else formErrors.abbreviation = null;
        break;
      default:
        break;
    }
    this.setState({ formErrors });
  };

  formIsIncomplete = () => {
    const { formData, formErrors } = this.state;
    return (
      !formData.name ||
      !formData.abbreviation ||
      formErrors.name ||
      formErrors.abbreviation
    );
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { dispatch, toggleEditContractorModal, isNew, userId, refreshList } =
      this.props;
    const formData = {
      ...this.state.formData,
      modifiedByUserId: userId,
    };
    if (!this.formIsIncomplete()) {
      if (isNew) {
        await dispatch(contractorActions.add(formData));
        refreshList && refreshList();
      } else {
        await dispatch(contractorActions.update(formData));
        refreshList && refreshList(false); // false to keep selected contractor in place
      }
      toggleEditContractorModal();
    }
  };

  render() {
    const { formData, formErrors } = this.state;
    const { showEditContractorModal, toggleEditContractorModal, isNew, fetching } =
      this.props;
    const closeBtn = (
      <button className="close" onClick={toggleEditContractorModal}>
        <FontAwesomeIcon icon="times" className="fa-fw text-white" />
      </button>
    );
    return (
      <React.Fragment>
        <Modal
          isOpen={showEditContractorModal}
          toggle={toggleEditContractorModal}
          className={this.props.className}
          size={"lg"}
          fade={false}
        >
          <ModalHeader
            toggle={toggleEditContractorModal}
            className="bg-info text-white"
            close={closeBtn}
          >
            <FontAwesomeIcon icon="edit" className="fa-fw mr-2" />
            {isNew ? "Add Contractor" : "Edit Contractor"}
          </ModalHeader>
          <ModalBody>
            <div className="card m-2">
              <div className="card-body">
                <div className="form-row form-group mb-2">
                  <label htmlFor="name" className="col-sm-3 col-form-label">
                    <b>Name:</b>*
                  </label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      name="name"
                      id="name"
                      className="form-control"
                      maxLength="50"
                      value={formData.name}
                      onChange={this.handleChange}
                    />
                  </div>
                  {formErrors.name && (
                    <span className="error-small">
                      <small>{formErrors.name}</small>
                    </span>
                  )}
                </div>
                <div className="form-row form-group mb-2">
                  <label htmlFor="abbreviation" className="col-sm-3 col-form-label">
                    <b>Abbrev.:</b>*
                  </label>
                  <div className="col-sm-5">
                    <input
                      type="text"
                      name="abbreviation"
                      id="abbreviation"
                      className="form-control"
                      maxLength="5"
                      value={formData.abbreviation}
                      onChange={this.handleChange}
                      onBlur={this.handleBlur}
                    />
                    {formErrors.abbreviation && (
                      <span className="error-small">
                        <small>{formErrors.abbreviation}</small>
                      </span>
                    )}
                  </div>
                </div>
                <div className="form-row form-group mb-0">
                  <div className="custom-control-inline custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      name="isJointVenture"
                      id="isJointVenture"
                      className="custom-control-input my-auto"
                      value={formData.isJointVenture}
                      checked={formData.isJointVenture}
                      onChange={this.handleChange_check}
                    />
                    <label
                      htmlFor="isJointVenture"
                      className="custom-control-label my-auto"
                    >
                      Joint venture
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter className="bg-lightgray">
            <div className="form-row form-group mb-0">
              <button
                type="button"
                className="btn btn-primary mr-2"
                name="editPcDetailsSubmit"
                onClick={this.handleSubmit}
                disabled={this.formIsIncomplete() || fetching}
              >
                {fetching && (
                  <span className="mr-2 mt-1">
                    <FontAwesomeIcon icon="spinner" style={{ color: "white" }} spin />
                  </span>
                )}
                {`${
                  isNew ? (fetching ? "Adding" : "Add") : fetching ? "Saving" : "Save"
                }`}
              </button>
              <button
                className="btn btn-secondary"
                color="secondary"
                onClick={toggleEditContractorModal}
              >
                Cancel
              </button>
            </div>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  fetching: state.contractors.fetching,
  contractor: state.contractors.openContractorDetails[ownProps.projectId]
    ? state.contractors.openContractorDetails[ownProps.contractorId] || null
    : null,
  userId: state.authentication.user.userId,
});

export default connect(mapStateToProps)(EditContractorModal);
